import React, { useEffect } from 'react';

import { Row, Col, Form } from "react-bootstrap";
import useInput from '../hooks/useInput';

import typeCntracts from '../config/_typeContract'

const FormSalarySettlement = ({contract, dayMonth, eventParent}) => {
    
    const { value, setValue, onChange } = useInput({});

    useEffect(() => {
        if(contract){ 
            contract.dayByMonth = dayMonth;
            setValue(contract)
        }
        else{
            setValue({
            salary: null,
            hiringDate: null,
            workPosition: null,
            entryTime: null,
            departureTime: null,
            dayByMonth: null,
            typeContract: null,
            });
        }
         // eslint-disable-next-line
    }, [contract])

    useEffect(() => {
        eventParent(value);
         // eslint-disable-next-line
    }, [value])


    return ( 
        <Form>
            <Form.Group as={Row} controlId="formHorizontalEmail">
            <Form.Label column sm={3}>
                    Tipo de Contrato
                </Form.Label>
                <Col sm={9}>
                    <Form.Control as="select" custom  name="typeContract" onChange={onChange}  required={true}>
                        {!value.typeContract ? <option>Seleccionar...</option> : null }
                        {typeCntracts.map(type => (
                            <option 
                                value={type.name} 
                                selected={type.name === value.typeContract}
                                >
                                {type.name}
                            </option>
                        ))}
                    </Form.Control>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalEmail">
                <Form.Label column sm={3}>
                    Cargo del Trabajador
                </Form.Label>
                <Col sm={9}>
                    <Form.Control 
                        type="text" 
                        name="workPosition"
                        placeholder="Leader Teach" 
                        size="" 
                       // disabled={isRoleUser} 
                        value={value.workPosition}
                        onChange={onChange} 
                        required={true}/>
                </Col>
            </Form.Group>
            
            <Form.Group as={Row} controlId="formHorizontalEmail">
                <Form.Label column sm={3}>
                    Sueldo Bruto
                </Form.Label>
                <Col sm={9}>
                    <Form.Control 
                        type="number" 
                        name="salary"
                        placeholder="2.200.000" 
                        size="" 
                       // disabled={isRoleUser} 
                        value={value.salary}
                        onChange={onChange} 
                        required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalEmail">
               <Form.Label column sm={3}>
                    Fecha de Contratación
                </Form.Label>
                
                <Col sm={9}>
                <Form.Control 
                    type="date" 
                    name="hiringDate"
                    placeholder="12-12-12" 
                    //disabled={isRoleUser} 
                    value={value.hiringDate}
                    onChange={onChange} 
                    required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalEmail">
                <Form.Label column sm={3}>
                    Hora de Entrada
                </Form.Label>
                <Col sm={9}>
                    <Form.Control 
                        type="time" 
                        name="entryTime"
                        placeholder="2.200.000" 
                        size="" 
                       // disabled={isRoleUser} 
                        value={value.entryTime}
                        onChange={onChange} 
                        required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalEmail">
                <Form.Label column sm={3}>
                    Hora de salida
                </Form.Label>
                <Col sm={9}>
                    <Form.Control 
                        type="time" 
                        name="departureTime"
                        placeholder="11.1111.111-1" 
                        size="" 
                       // disabled={isRoleUser} 
                        value={value.departureTime}
                        onChange={onChange} 
                        required={true}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formHorizontalEmail">
                <Form.Label column sm={3}>
                    Días de vacaciones por Mes
                </Form.Label>
                <Col sm={2}>
                    <Form.Control 
                        type="number" 
                        name="dayByMonth"
                        placeholder="1.25" 
                        size="" 
                       // disabled={isRoleUser} 
                        value={value.dayByMonth}
                        onChange={onChange} 
                        required={true}/>
                </Col>
            </Form.Group>
        </Form>
     );
}
 
export default FormSalarySettlement;